import { Icon } from '../../UI';

export interface ActionButtonProps {
  className?: string;
  isDisabled?: boolean;
  onClick?: any;
  size?: 'small' | 'large';
  text?: string;
  withoutText?: boolean;
  highlightIcon?: boolean;
  hideTextOnMobile?: boolean;
  iconPosition?: 'left' | 'right';
}

export const ActionButton = ({
  className = '',
  isDisabled,
  onClick,
  size,
  text,
  iconPosition = 'left',
  withoutText = false,
  hideTextOnMobile = false,
  highlightIcon = false,
}: ActionButtonProps) => {
  const handleClick = () => {
    if (onClick && !isDisabled) {
      onClick();
    }
  };

  return (
    <div
      className={`
        flex
        ${className}
        items-center
        ${size === 'large' ? 'font-semibold' : 'text-sm'}
        ${isDisabled ? 'pointer-events-none' : 'cursor-pointer'}
        ${iconPosition === 'left' ? 'flex-row' : 'flex-row-reverse'}
      `}
    >
      <div
        className={`
          flex
          justify-center
          items-center
          p-1
          ${size === 'large' ? 'w-8 h-8 rounded-2xl' : 'w-5 h-5 rounded-md'}
          ${
            highlightIcon
              ? 'bg-lime hover:bg-lime-dark-1 active:bg-lime dark:bg-lime dark:hover:bg-lime dark:hover:bg-lime-dark-1 dark:active:bg-lime dark:focus:bg-lime-dark-1'
              : 'bg-grey-10 hover:bg-primary active:bg-black-light dark:bg-grey-70 dark:hover:bg-lime dark:active:bg-white dark:focus:bg-lime'
          }
          dark:hover:text-black
        `}
        onClick={handleClick}
      >
        <Icon
          svgName={'plus'}
          canUseDarkMode={false}
          className={`
            select-none
            ${
              isDisabled
                ? 'text-grey-30'
                : 'text-black dark:group-hover:text-black dark:group-active:text-black'
            }
          select-none`}
        />
      </div>
      {text && !withoutText && (
        <p
          className={`
            w-max
            ${iconPosition === 'left' ? 'pl-2' : 'pr-2'}
            text-black dark:text-white
            ${isDisabled ? 'text-grey-30' : ''}
            select-none
            ${hideTextOnMobile ? 'hidden md:block' : ''}
          `}
        >
          {text}
        </p>
      )}
    </div>
  );
};
